import { TextCaption } from '@tkww/orion-web-ds-text';
import React from 'react';
import Styles from './AvailabilityLegend.scss';

export const AvailabilityLegend = () => {
	return (
		<div className={Styles.legendContainer}>
			<div className={Styles.legendIcon} />
			<div>
				<TextCaption size="lg">Availability</TextCaption>
			</div>
			<div className={`${Styles.legendIcon} ${Styles.partial}`} />
			<div>
				<TextCaption size="lg">Partially available</TextCaption>
			</div>
		</div>
	);
};
